// extracted by mini-css-extract-plugin
export default {"prLaneBadge":"P9cKnNV2WIg8CDlqrIDt"};